import Swal from 'sweetalert2';

/**
 * Estilos e iconos compartidos por los modales del flujo de refacturación
 * (vista de la factura y formulario de facturar servicio). Se aplican por JS
 * porque SweetAlert2 monta el popup fuera del componente y el CSS con
 * encapsulación de Angular no lo alcanza.
 */

export const REFACTURA_BLUE = '#00A0E1';
export const REFACTURA_GREEN = '#4CAF50';

/**
 * Icono de refacturación: 30×33, trazo 2px.
 * Hoja (#00A0E1) con la esquina doblada abajo a la derecha
 * y el tache (#141B34) arriba a la izquierda.
 */
export const REFACTURA_FILE_ICON = `
    <svg width="30" height="33" viewBox="0 0 30 33" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M10 5h16a2 2 0 0 1 2 2v17l-7 7H10a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z"
              stroke="${REFACTURA_BLUE}" stroke-width="2" stroke-linejoin="round"/>
        <path d="M21 31v-5a2 2 0 0 1 2-2h5" stroke="${REFACTURA_BLUE}" stroke-width="2" stroke-linejoin="round"/>
        <circle cx="7.5" cy="7" r="8.3" fill="#FFFFFF"/>
        <path d="m2.5 2 10 10M12.5 2l-10 10" stroke="#141B34" stroke-width="2" stroke-linecap="round"/>
    </svg>`;

/** Círculo con palomita verde (progreso y confirmación). */
export const REFACTURA_CHECK_ICON = `
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="22" cy="22" r="20" stroke="${REFACTURA_GREEN}" stroke-width="2"/>
        <path d="m13 22.5 6 6 12-13.5" stroke="${REFACTURA_GREEN}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

/** Párrafo gris centrado bajo el título. */
export function refacturaBodyText(text: string): string {
    return `<span style="display:block;color:#7A7A7A;font-family:Lato,sans-serif;`
        + `font-size:16px;line-height:1.45;text-align:center">${text}</span>`;
}

interface RefacturaModalStyles {
    width?: string;
    /** El título de dos líneas necesita más aire que el de una. */
    titleLineHeight?: string;
}

/**
 * Aplica el look del flujo a un popup ya abierto. Va dentro de `didOpen`.
 */
export function styleRefacturaModal(options: RefacturaModalStyles = {}): void {
    const { width = '526px', titleLineHeight = '100%' } = options;

    const popup = Swal.getPopup();
    if (popup) {
        popup.style.borderRadius = '16px';
        popup.style.width = width;
    }

    // El icono va montado sobre el contenedor de icono de Swal: le quitamos
    // el círculo con borde para que quede sólo el SVG, centrado sobre el título.
    const iconEl = Swal.getIcon();
    if (iconEl) {
        iconEl.style.cssText = 'border:none;width:auto;height:auto;margin:16px auto 4px;';
        const iconContent = iconEl.querySelector('.swal2-icon-content') as HTMLElement | null;
        if (iconContent) {
            iconContent.style.cssText = 'font-size:0;line-height:0;';
        }
    }

    const titleEl = Swal.getTitle();
    if (titleEl) {
        titleEl.style.cssText = 'color:#545454;font-family:Poppins,sans-serif;font-weight:600;'
            + `font-size:20px;line-height:${titleLineHeight};letter-spacing:0px;text-align:center;`
            + 'display:block;width:100%;margin:0 auto;padding:12px 1em 0;';
    }

    const closeBtn = Swal.getCloseButton();
    if (closeBtn) {
        closeBtn.style.color = '#000000';
    }

    // Con reverseButtons el cancelar queda a la izquierda (contorno) y el
    // confirmar a la derecha (relleno), como en el diseño.
    const base = 'border:1px solid ' + REFACTURA_BLUE + ';border-radius:0.5rem;padding:0 16px;'
        + 'height:40px;width:190px;margin:0 6px;font-weight:500;';
    styleButton(Swal.getCancelButton(), `background:#FFFFFF;color:${REFACTURA_BLUE};${base}`);
    styleButton(Swal.getConfirmButton(), `background:${REFACTURA_BLUE};color:#FFFFFF;${base}`);
}

/**
 * Swal oculta los botones que no se piden con `display:none` inline, y
 * reescribir cssText lo borraría (un modal sin botones mostraría uno). Por eso
 * el display se conserva.
 */
function styleButton(button: HTMLElement | null, css: string): void {
    if (!button) return;
    const display = button.style.display;
    button.style.cssText = css;
    if (display) button.style.display = display;
}
